var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,11.654V8.346l-2.712-.534A7.565,7.565,0,0,0,16.7,6.394l1.513-2.269L15.875,1.788,13.606,3.3a7.562,7.562,0,0,0-1.418-.589L11.654,0H8.346L7.812,2.712A7.565,7.565,0,0,0,6.394,3.3L4.125,1.788,1.788,4.125,3.3,6.394a7.565,7.565,0,0,0-.589,1.418L0,8.346v3.307l2.712.534A7.566,7.566,0,0,0,3.3,13.606L1.788,15.875l2.337,2.337L6.394,16.7a7.564,7.564,0,0,0,1.418.589L8.346,20h3.307l.534-2.712a7.564,7.564,0,0,0,1.418-.589l2.269,1.513,2.337-2.337L16.7,13.606a7.565,7.565,0,0,0,.589-1.418Zm-3.3,4.072-.978.978-2.081-1.387A6.825,6.825,0,0,1,11.18,16.34l-.49,2.488H9.31L8.82,16.34a6.826,6.826,0,0,1-2.464-1.023L4.274,16.7,3.3,15.726l1.387-2.081A6.825,6.825,0,0,1,3.66,11.18l-2.488-.49V9.31L3.66,8.82A6.831,6.831,0,0,1,4.684,6.355L3.3,4.274,4.274,3.3,6.355,4.684A6.825,6.825,0,0,1,8.82,3.66l.49-2.488h1.38l.49,2.488a6.825,6.825,0,0,1,2.464,1.023L15.726,3.3l.978.978L15.316,6.355A6.828,6.828,0,0,1,16.34,8.82l2.488.49v1.38l-2.488.49a6.823,6.823,0,0,1-1.023,2.464Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.898 5.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M155.1,151a4.1,4.1,0,1,0,4.1,4.1A4.106,4.106,0,0,0,155.1,151Zm0,7.031a2.93,2.93,0,1,1,2.93-2.93A2.933,2.933,0,0,1,155.1,158.031Z",
    transform: "translate(-151 -151)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.94fc26459e998d1fd9f09db6be5190e1.svg";
export { ForwardRef as ReactComponent };